import { Stack, StackProps, styled } from "@mui/material";
import { Star } from "lucide-react";

export const CtaOverlayContainer = styled(Stack)<{ isMobile:boolean, mobileCtaOverlayShow: boolean }>(({ 
  theme,
  isMobile,
  mobileCtaOverlayShow
}) => ({
  backgroundColor: theme.customColors.backgroundPrimary,
  border: `2px solid ${theme.customColors.textPrimary}`,
  borderRadius: "0.5rem",
  bottom: "1rem",
  flexDirection: "row",
  height: "2.5rem",
  // overflow: "hidden",
  display: "flex",
  position: "absolute",
  right: !isMobile ? "2.5rem" : "1rem",
  zIndex: 999,
  ".button":{
    borderRight: `2px solid ${theme.customColors.textPrimary}`
  },
  ".button:last-child":{
    borderRight: "none",
    borderTopRightRadius: "0.5rem",
    borderBottomRightRadius: "0.5rem"
  },
  ".button:first-child":{
    borderTopLeftRadius: "0.5rem",
    borderBottomLeftRadius: "0.5rem"
  },
  ".button:focus":{
    backgroundColor: theme.customColors.backgroundSecondaryCtaHover
  },
  ...(isMobile) && {
    display: !mobileCtaOverlayShow ? "none" : "flex",
    bottom: "4rem"
  }
}));

export const StarsBoxContainer = styled(Stack)<
  StackProps & {
    $visibility?: boolean,
    $isMobile?: boolean
  }
>(({ $visibility=false, theme, $isMobile }) => ({
  alignItems: "center",
  background: theme.customColors.backgroundPrimary,
  border: `2px solid ${theme.customColors.textPrimary}`,
  borderRadius: "0.5rem",
  display: "flex",
  flexDirection: "row", 
  // flexDirection: "row", 
  gap: "0.7rem",
  height: "2.5rem",
  justifyContent:"center",
  left: !$isMobile ? "50%" : "-2.25rem",
  padding: "0.78rem",
  position: "absolute",
  top: $visibility ? "-0.5rem" : "0.5rem",
  opacity: $visibility ? 1 : 0,
  transform: "translate(-50%, -100%)",
  transition: "all 0.2s ease-out"
}));





export const StarIcon = styled(Star)(() => ({
  cursor: "pointer",
  transition: "all 0.15s",
  ":focus:not(:focus-visible)": {
    outline: "none"
  }
}));
